import { render, staticRenderFns } from "./ConsComprobanteContable.vue?vue&type=template&id=1cfff334"
import script from "./ConsComprobanteContable.vue?vue&type=script&lang=js"
export * from "./ConsComprobanteContable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports